import React from "react";
import DefaultLayout from "../../layouts/default";

import IncidentDashboardHeader from "./components/IncidentDashboardHeader";
import IncidentLogTable from "./components/IncidentLogTable";
import IncidentAnalyticsPanels from "./components/IncidentAnalyticsPanels";
import IncidentDashboardBottom from "./components/IncidentDashboardBottom";

import { IncidentProvider } from "./context/incidentContext";
import IncidentRecordsDialog from './components/IncidentRecordsDialog';
import IncidentRecordManagement from './components/IncidentRecordManagement';

function IncidentPage() {
  return (
    <DefaultLayout>
      <IncidentProvider>
        <div className="w-full min-h-screen bg-slate-50/50 p-4 md:p-6 flex flex-col gap-6">
          {/* Row 1: Dashboard Header Controls and Status Cards */}
          <div className="w-full">
            <IncidentDashboardHeader />
          </div>

          {/* Row 2: Split Layout */}
          <div className="w-full flex flex-col lg:flex-row gap-6 items-start">
            {/* Main Incidents Table */}
            <div className="w-full lg:flex-1 min-w-0">
              <IncidentLogTable />
            </div>

            {/* Aging & Compliance Category Sidebar */}
            <div className="w-full lg:w-[360px] xl:w-[380px] shrink-0">
              <IncidentAnalyticsPanels />
            </div>
          </div>

          {/* Row 3: Lower Metrics Panels */}
          <div className="w-full">
            <IncidentDashboardBottom />
          </div>
        </div>
        <IncidentRecordsDialog />
        <IncidentRecordManagement />
      </IncidentProvider>
    </DefaultLayout>
  );
}

export default IncidentPage;
